import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Badge } from "../ui/badge";
import { Plus, CheckCircle } from "lucide-react";

export const ExtrasSelection = ({ extras, selectedExtras, onToggle, extrasTotal }) => {
  if (extras.length === 0) return null;

  return (
    <Card className="dashboard-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Plus className="h-5 w-5 text-primary" />
          Add Extras
        </CardTitle>
        <CardDescription>Optional add-ons for your booking</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {extras.map(extra => (
            <div
              key={extra.id}
              onClick={() => onToggle(extra.id)}
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                selectedExtras.includes(extra.id)
                  ? "border-primary bg-primary/10"
                  : "border-black/10 hover:border-white/20 bg-secondary/30"
              }`}
              data-testid={`extra-${extra.id}`}
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <div className={`mt-1 h-4 w-4 rounded-sm border flex items-center justify-center ${
                    selectedExtras.includes(extra.id) 
                      ? "bg-primary border-primary" 
                      : "border-white/30"
                  }`}>
                    {selectedExtras.includes(extra.id) && (
                      <CheckCircle className="h-3 w-3 text-primary-foreground" />
                    )}
                  </div>
                  <div>
                    <p className="font-medium">{extra.name}</p>
                    <p className="text-xs text-muted-foreground">{extra.description}</p>
                  </div>
                </div>
                <Badge variant="secondary" className="ml-2">+${(extra.price || 0).toFixed(2)}</Badge>
              </div>
            </div>
          ))}
        </div>
        {selectedExtras.length > 0 && (
          <div className="mt-4 p-3 bg-primary/10 rounded-lg flex items-center justify-between">
            <span className="text-sm">Extras Total:</span>
            <span className="font-bold text-primary">+${(extrasTotal || 0).toFixed(2)}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
